
import { defineComponent, getCurrentInstance } from "vue";
import { useI18n } from "@composables/i18n";
import CiButton from "@components/base/button.vue";

export default defineComponent({
  name: "CiUsersProfileDescription",
  components: { CiButton },
  inject: {
    slug: "userSlug",
  },
  props: {
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    textWithFallback(): string {
      const { t } = useI18n(getCurrentInstance());
      return this.text || (t("ui.components.users.profile.description.empty_state") as string);
    },
  },
});
